import { render, staticRenderFns } from "./MiniAuth.vue?vue&type=template&id=1e98cd02&scoped=true"
import script from "./MiniAuth.vue?vue&type=script&lang=js"
export * from "./MiniAuth.vue?vue&type=script&lang=js"
import style0 from "./MiniAuth.vue?vue&type=style&index=0&id=1e98cd02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e98cd02",
  null
  
)

export default component.exports